import { memo } from 'react';
import { DoubleCitizenshipVM } from 'mutation/view-models/registration-citizenship';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ArticleList from '../shared/article-list';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import ReasonDoubleCitizenship from './reason-double-citizenship-list';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

interface OpenLegisProps {
  values?: DoubleCitizenshipVM;
  onChange: (
    key: keyof DoubleCitizenshipVM,
    value: DoubleCitizenshipVM[keyof DoubleCitizenshipVM]
  ) => void;
  idReason: string;
  disabled?: boolean;
}

const DoubleCitizenshipComponent = ({
  onChange,
  values,
  idReason,
  disabled,
}: OpenLegisProps): React.ReactElement => {
  const onChangeArticleList = useEventCallback((value: ItemVM<MotArtCitizenship> | null) => {
    onChange('article', value);
  });

  const handleForeignStateListChange = useEventCallback(
    (citizenship: ForeignStateVM | null | undefined) => {
      onChange('citizenship', citizenship);
    }
  );

  const onChangeReasonDoubleCitizenship = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('reasonCitizenship', event.target.value);
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Doppia citt. dal"
          aria-label="Doppia citt. dal"
          value={values?.dateFrom || null}
          onChange={(date) => {
            onChange('dateFrom', date);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateFrom" {...params} fullWidth helperText="" disabled={disabled} />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ForeignStateList
          label="Cittadinanza"
          aria-label="Cittadinanza"
          id="citizenship"
          value={values?.citizenship || null}
          onChange={handleForeignStateListChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ArticleList
          value={values?.article?.id?.toString() || ''}
          onChange={onChangeArticleList}
          idReason={idReason}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ReasonDoubleCitizenship
          value={values?.reasonCitizenship || ''}
          onChange={onChangeReasonDoubleCitizenship}
          label="Motivo"
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

DoubleCitizenshipComponent.displayName =
  'Form Accordion Registration Citizenship - DoubleCitizenship component';

const DoubleCitizenship = memo(DoubleCitizenshipComponent);

export default DoubleCitizenship;
